module.exports = __webpack_public_path__ + "img/ma.95b9645b.png";